// mock t function for i18next scanner to pick up
const t = (x: string) => x

export enum EbKaszStatusCombo {
    eEKSC_ToDo = 0,
    eEKSC_NichtKontiert = 1,
    eEKSC_NichtGebucht = 2,
    eEKSC_Unvollstaendig = 3,
    eEKSC_Importiert = 4,
    eEKSC_TeilweiseKontiert = 5,
    eEKSC_Kontiert = 6,
    eEKSC_TeilweiseGebucht = 7,
    eEKSC_Gebucht = 8,
    eEKSC_ZeilenToDo = 9,
    eEKSC_ZeilenMehrereRegel = 10,
    eEKSC_ZeilenZielGefudnen = 11,
    eEKSC_ZeilenLzPruefen = 12,
    eEKSC_ZeilenBuErrStorno = 13,
    eEKSC_ZeilenKontiert = 14,
}

export const EbKaszStatusComboLabels: {[k: string]: string} = {
    [EbKaszStatusCombo.eEKSC_ToDo]: t('2031:enum.EbKaszStatusCombo.eEKSC_ToDo'),
    [EbKaszStatusCombo.eEKSC_NichtKontiert]: t('2031:enum.EbKaszStatusCombo.eEKSC_NichtKontiert'),
    [EbKaszStatusCombo.eEKSC_NichtGebucht]: t('2031:enum.EbKaszStatusCombo.eEKSC_NichtGebucht'),
    [EbKaszStatusCombo.eEKSC_Unvollstaendig]: t('2031:enum.EbKaszStatusCombo.eEKSC_Unvollstaendig'),
    [EbKaszStatusCombo.eEKSC_Importiert]: t('2031:enum.EbKaszStatusCombo.eEKSC_Importiert'),
    [EbKaszStatusCombo.eEKSC_TeilweiseKontiert]: t('2031:enum.EbKaszStatusCombo.eEKSC_TeilweiseKontiert'),
    [EbKaszStatusCombo.eEKSC_Kontiert]: t('2031:enum.EbKaszStatusCombo.eEKSC_Kontiert'),
    [EbKaszStatusCombo.eEKSC_TeilweiseGebucht]: t('2031:enum.EbKaszStatusCombo.eEKSC_TeilweiseGebucht'),
    [EbKaszStatusCombo.eEKSC_Gebucht]: t('2031:enum.EbKaszStatusCombo.eEKSC_Gebucht'),
    [EbKaszStatusCombo.eEKSC_ZeilenToDo]: t('2031:enum.EbKaszStatusCombo.eEKSC_ZeilenToDo'),
    [EbKaszStatusCombo.eEKSC_ZeilenMehrereRegel]: t('2031:enum.EbKaszStatusCombo.eEKSC_ZeilenMehrereRegel'),
    [EbKaszStatusCombo.eEKSC_ZeilenZielGefudnen]: t('2031:enum.EbKaszStatusCombo.eEKSC_ZeilenZielGefudnen'),
    [EbKaszStatusCombo.eEKSC_ZeilenLzPruefen]: t('2031:enum.EbKaszStatusCombo.eEKSC_ZeilenLzPruefen'),
    [EbKaszStatusCombo.eEKSC_ZeilenBuErrStorno]: t('2031:enum.EbKaszStatusCombo.eEKSC_ZeilenBuErrStorno'),
    [EbKaszStatusCombo.eEKSC_ZeilenKontiert]: t('2031:enum.EbKaszStatusCombo.eEKSC_ZeilenKontiert'),
}

export const ebKaszStatusComboToOpts = (t: Function, settings: any) => {
    const opts = []

    for(let x in EbKaszStatusCombo) {
        if (!isNaN(Number(x))) { continue }


        opts.push({
            name: t(EbKaszStatusComboLabels[EbKaszStatusCombo[x as keyof typeof EbKaszStatusCombo]]),
            value: EbKaszStatusCombo[x as keyof typeof EbKaszStatusCombo],
        })
    }

    return opts
}
